export function floor(number, precision) {
    var multiplier = !!precision ? Math.pow(10, precision) : 1;
    return Math.floor(number * multiplier) / multiplier;
}
//# sourceMappingURL=floor.js.map